module.exports = "<p>\n  leave works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/employee-claims/leave/leave.component.html
// module id = ./src/app/hrms/employee-claims/leave/leave.component.html
// module chunks = main